














import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrencyTransaction5TransactionSettingsIntroduction from './-5-transaction-settings-introduction.vue'

@Component({
  components: {
    DigitalCurrencyTransaction5TransactionSettingsIntroduction
  }
})
class DigitalCurrencyTransaction4TransactionSettingsButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean

  @Prop({ default: null }) initialTransaction?: any

  isVisibleTransactionSettingsDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleTransactionSettingsDialog = isVisible
  }
}

export default DigitalCurrencyTransaction4TransactionSettingsButton

